import { render } from "./RappelAccordion.vue?vue&type=template&id=20117df2"
import script from "./RappelAccordion.vue?vue&type=script&lang=js"
export * from "./RappelAccordion.vue?vue&type=script&lang=js"

import "./RappelAccordion.vue?vue&type=style&index=0&id=20117df2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__